/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audio_Description_Export_Preset_LoadedInputs */

const en_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" loaded`)
};

const fr_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Préréglage "${i?.name}" chargé`)
};

const de_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voreinstellung "${i?.name}" geladen`)
};

const it_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preimpostazione "${i?.name}" caricata`)
};

const ru_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Загружен пресет "${i?.name}".`)
};

const es_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preajuste "${i?.name}" cargado`)
};

const zh_cn2_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预设“${i?.name}”已加载`)
};

const ja_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセット「${i?.name}」がロードされました`)
};

const hi_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रीसेट "${i?.name}" लोड हो गया`)
};

const pt_pt2_audio_description_export_preset_loaded = /** @type {(inputs: Audio_Description_Export_Preset_LoadedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Predefinição "${i?.name}" carregada`)
};

/**
* | output |
* | --- |
* | "Preset \"{name}\" loaded" |
*
* @param {Audio_Description_Export_Preset_LoadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_loaded = /** @type {((inputs: Audio_Description_Export_Preset_LoadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_LoadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_preset_loaded(inputs)
	if (locale === "de") return de_audio_description_export_preset_loaded(inputs)
	if (locale === "it") return it_audio_description_export_preset_loaded(inputs)
	if (locale === "ru") return ru_audio_description_export_preset_loaded(inputs)
	if (locale === "es") return es_audio_description_export_preset_loaded(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_preset_loaded(inputs)
	if (locale === "ja") return ja_audio_description_export_preset_loaded(inputs)
	if (locale === "hi") return hi_audio_description_export_preset_loaded(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_preset_loaded(inputs)
	return en_audio_description_export_preset_loaded(inputs)
});